import TutorsLayoutWrapper from "../pages/_tutor-layout";
import MyCalendar from "../pages/_tutor-layout/calendar/MyCalendar";
import ListMyDocumentsWrapper from "../pages/_tutor-layout/documents/ListMyDocumentsWrapper";
import ListMyInvoicesWrapper from "../pages/_tutor-layout/invoices/ListMyInvoicesWrapper";
import TutorProfile from "../pages/_tutor-layout/profile/TutorProfile";
import MyTutorials from "../pages/_tutor-layout/tutorials/MyTutorials";
import ClientsWrapper from "../pages/clients";
import ClientCreate from "../pages/clients/create/ClientCreate";
import ClientEdit from "../pages/clients/edit/ClientEdit";
import ClientsListWrapper from "../pages/clients/list/ClientsListWrapper";
import ClientActivityHistoryWrapper from "../pages/clients/profile/views/activity-history/ClientActivityHistoryWrapper";
import ClientComments from "../pages/clients/profile/views/comments/ClientComments";
import ClientCommercialNetworks from "../pages/clients/profile/views/commercial-networks/ClientCommercialNetworks";
import ClientConsultancy from "../pages/clients/profile/views/consultancy/ClientConsultancy";
import ClientContractsWrapper from "../pages/clients/profile/views/contracts/ClientContractsWrapper";
import ClientCreditHistory from "../pages/clients/profile/views/credit-history/ClientCreditHistory";
import ClientInfo from "../pages/clients/profile/views/info/ClientInfo";
import ClientInvoicesWrapper from "../pages/clients/profile/views/invoices/ClientInvoicesWrapper";
import ClientStudents from "../pages/clients/profile/views/students/ClientStudents";
import ConsultanciesWrapper from "../pages/consultancy";
import CreateConsultancy from "../pages/consultancy/create/CreateConsultancy";
import EditConsultancy from "../pages/consultancy/edit/EditConsultancy";
import ConsultanciesListWrapper from "../pages/consultancy/list/ConsultanciesListWrapper";
import ContractsLayoutWrapper from "../pages/contracts";
import ContractCreate from "../pages/contracts/create/ContractCreate";
import ContractEdit from "../pages/contracts/edit/ContractEdit";
import ContractsListWrapper from "../pages/contracts/list/ContractListWrapper";
import ContractChangelogsWrapper from "../pages/contracts/profile/views/activity-history/ContractActivityHistoryWrapper";
import ContractCalls from "../pages/contracts/profile/views/calls/ContractCalls";
import ContractComments from "../pages/contracts/profile/views/comments/ContractComments";
import ContractDocuments from "../pages/contracts/profile/views/documents/ContractDocuments";
import ContractFacilitatorExtras from "../pages/contracts/profile/views/extras/ContractFacilitatorExtras";
import ContractIncidenceWrapper from "../pages/contracts/profile/views/incidence/ContractIncidenceWrapper";
import ContractInfo from "../pages/contracts/profile/views/info/ContractInfo";
import ContractInvoicing from "../pages/contracts/profile/views/invoicing/ContractInvoicing";
import ContractScoresHistory from "../pages/contracts/profile/views/scores-history/ContractScoresHistory";
import ContractStatesHistoryWrapper from "../pages/contracts/profile/views/states-history/ContractStatesHistoryWrapper";
import ContractFacilitatorTracking from "../pages/contracts/profile/views/tracking/ContractFacilitatorTracking";
import CorporationsWrapper from "../pages/corporations";
import CorporationDetailPage from "../pages/corporations/detail/CorporationDetailPage";
import CorporationsListWrapper from "../pages/corporations/list/CorporationsListWrapper";
import Dashboard from "../pages/dashboard/Dashboard";
import DepartmentsWrapper from "../pages/departments";
import DepartmentDetailPage from "../pages/departments/detail/DepartmentDetailPage";
import DepartmentsListWrapper from "../pages/departments/list/DepartmentsListWrapper";
import ExpirationWrapper from '../pages/expiration';
import ExpirationCreate from "../pages/expiration/create/ExpirationCreate";
import ExpirationEdit from "../pages/expiration/edit/ExpirationEdit";
import ExpirationListWrapper from "../pages/expiration/expiration-list/ExpirationListWrapper";
import ViewExpiration from '../pages/expiration/expiration-view/ViewExpiration';
import GeneralConfigurationWrapper from "../pages/general-configuration";
import ConfigListWrapper from "../pages/general-configuration/ConfigListWrapper";
import IncidencesWrapper from "../pages/incidences";
import IncidenceCreate from "../pages/incidences/create/IncidenceCreate";
import IncidenceEdit from "../pages/incidences/edit/IncidenceEdit";
import IncidencesListWrapper from "../pages/incidences/list/IncidencesListWrapper";
import TutorIncidencesListWrapper from "../pages/incidences/list/TutorIncidencesListWrapper";
import IncidenceComments from "../pages/incidences/profile/views/comments/IncidenceComments";
import IncidenceDocuments from "../pages/incidences/profile/views/documents/IncidenceDocuments";
import IncidenceInfo from "../pages/incidences/profile/views/info/IncidenceInfo";
import IncidenceTypesWrapper from "../pages/incidences/types";
import IncidenceTypeCreate from "../pages/incidences/types/create/IncidenceTypeCreate";
import IncidenceTypeEdit from "../pages/incidences/types/edit/IncidenceTypeEdit";
import IncidenceTypesListWrapper from "../pages/incidences/types/list/IncidenceTypesListWrapper";
import InvoicesWrapper from "../pages/invoicing";
import NonStandardInvoiceCreate from "../pages/invoicing/create/NonStandardInvoiceCreate";
import InvoiceEdit from "../pages/invoicing/edit/InvoiceEdit";
import InvoicesListWrapper from "../pages/invoicing/list/InvoicesListWrapper";
import InvoiceActivityHistoryWrapper from "../pages/invoicing/profile/views/activity-history/InvoiceActivityHistoryWrapper";
import InvoiceExpirations from "../pages/invoicing/profile/views/expirations/InvoiceExpirations";
import InvoiceInfo from "../pages/invoicing/profile/views/info/InvoiceInfo";
import LeadsWrapper from "../pages/leads";
import LeadEdit from "../pages/leads/edit/LeadEdit";
import LeadListWrapper from "../pages/leads/list/LeadListWrapper";
import LeadComments from "../pages/leads/profile/views/comments/LeadComments";
import LeadInfo from "../pages/leads/profile/views/info/LeadInfo";
import LeadStatusHistory from "../pages/leads/profile/views/status-history/LeadStatusHistory";
import NetworksWrapper from "../pages/networks";
import NetworkDetailPage from "../pages/networks/detail/NetworkDetailPage";
import NetworksListWrapper from "../pages/networks/list/NetworksListWrapper";
import NetworkSettlementsListWrapper from "../pages/networks/settlements/NetworkSettlementsListWrapper";
import NetworkSettlementContractsListWrapper from "../pages/networks/settlements/NetworkSettlementContractsListWrapper";
import OrderWrapper from "../pages/orders";
import OrdersCalendarPage from "../pages/orders/calendar/OrdersCalendarPage";
import OrderCreate from "../pages/orders/create/OrderCreate";
import OrderEdit from "../pages/orders/edit/OrderEdit";
import OrdersList from "../pages/orders/list/OrdersList";
import OrdersListWrapper from "../pages/orders/list/OrdersListWrapper";
import OrderProfileWrapper from "../pages/orders/profile/OrderProfileWrapper";
import ContractAssignment from "../pages/orders/profile/views/assignments/ContractAssignment";
import OrderCampaigns from "../pages/orders/profile/views/campaigns/OrderCampaigns";
import OrderContracts from "../pages/orders/profile/views/contracts/OrderContracts";
import ContractExports from "../pages/orders/profile/views/exports/ContractExports";
import OrderGroupCodes from "../pages/orders/profile/views/group-codes/OrderGroupCodes";
import OrderInfo from "../pages/orders/profile/views/info/OrderInfo";
import OrderStats from "../pages/orders/profile/views/stats/OrderStats";
import OrderXmlHistory from "../pages/orders/profile/views/xml-history/OrderXmlHistory";
import OrderTypesWrapper from "../pages/orders/types";
import OrderTypeCreate from "../pages/orders/types/create/OrderTypeCreate";
import OrderTypeEdit from "../pages/orders/types/edit/OrderTypeEdit";
import OrderTypesListWrapper from "../pages/orders/types/list/OrderTypesListWrapper";
import OrganisationWrapper from "../pages/organisations";
import OrganisationCreate from "../pages/organisations/create/OrganisationCreate";
import OrganisationEdit from "../pages/organisations/edit/OrganisationEdit";
import OrganisationsListWrapper from "../pages/organisations/list/OrganisationsListWrapper";
import ProductsWrapper from "../pages/products";
import ProductCreate from "../pages/products/create/ProductCreate";
import ProductEdit from "../pages/products/edit/ProductEdit";
import InspectorCredentialsCreate from "../pages/inspector-credentials/create/InspectorCredentialsCreate";
import InspectorCredentialsEdit from "../pages/inspector-credentials/edit/InspectorCredentialsEdit";
import InspectorCredentialsListWrapper from "../pages/inspector-credentials/InspectorCredentialsListWrapper";
import ProductsListWrapper from "../pages/products/list/ProductsListWrapper";
import RankingsIndexWrapper from "../pages/rankings";
import RankingInfo from "../pages/rankings/info/RankingInfo";
import RankingsPage from "../pages/rankings/list/RankingsPage";
import UsersRankingsListWrapper from "../pages/rankings/list/UsersRankingListWrapper";
import RemittancesWrapper from "../pages/remittances";
import RemittancesListWrapper from "../pages/remittances/list/RemittancesListWrapper";
import RolesWrapper from "../pages/roles";
import RoleCreate from "../pages/roles/create/RoleCreate";
import RoleEdit from "../pages/roles/edit/RoleEdit";
import RolesListWrapper from "../pages/roles/list/RolesListWrapper";
import SettingsWrapper from "../pages/settings";
import ContractsSettingsPage from "../pages/settings/contracts/ContractsSettingsPage";
import EventsSettingsPage from "../pages/settings/events/EventsSettingsPage";
import GeneralsSettingsPage from "../pages/settings/GeneralsSettingsPage";
import OrdersSettingsPage from "../pages/settings/orders/OrdersSettingsPage";
import HolidaysSettingsPage from "../pages/settings/holidays/HolidaysSettingsPage";
import ProductTypesSettingsPage from "../pages/settings/product-types/ProductTypesSettingsPage";
import DocumentTypesSettingsPage from "../pages/settings/document-types/DocumentTypesSettingsPage";
import FundaeGroupingsSettingsPage from "../pages/settings/fundae-groupings/FundaeGroupingsSettingsPage";
import TrainingActionGroupsSettingsPage from "../pages/settings/training-action-groups/TrainingActionGroupsSettingsPage";
import ProfessionalAreasSettingsPage from "../pages/settings/professional-areas/ProfessionalAreasSettingsPage";
import TrainingModalitiesSettingsPage from "../pages/settings/training-modalities/TrainingModalitiesSettingsPage";
import RankingsSettingsPage from "../pages/settings/rankings/RankingsSettingsPage";
import TemplatesSettingsPage from "../pages/settings/templates/TemplatesSettingsPage";
import TutorSettingsPage from "../pages/settings/tutors/TutorSettingsPage";
import StatesWrapper from "../pages/states";
import StateCreate from "../pages/states/create/StateCreate";
import StateEdit from "../pages/states/edit/StateEdit";
import KoReasonsListWrapper from "../pages/states/ko-reasons/KoReasonsListWrapper";
import KoReasonCreate from "../pages/states/ko-reasons/create/KoReasonCreate";
import KoReasonEdit from "../pages/states/ko-reasons/edit/KoReasonEdit";
import StatesListWrapper from "../pages/states/list/StatesListWrapper";
import StudentsWrapper from "../pages/students";
import StudentCreate from "../pages/students/create/StudentCreate";
import StudentEdit from "../pages/students/edit/StudentEdit";
import StudentsListWrapper from "../pages/students/list/StudentsListWrapper";
import StudentActivityHistoryWrapper from "../pages/students/profile/views/activity-history/StudentActivityHistoryWrapper";
import StudentInfo from "../pages/students/profile/views/info/StudentInfo";
import TutorsWrapper from "../pages/tutors";
import TutorCreate from "../pages/tutors/create/TutorCreate";
import TutorEdit from "../pages/tutors/edit/TutorEdit";
import TutorsListWrapper from "../pages/tutors/list/TutorsListWrapper";
import TutorContracts from "../pages/tutors/profile/views/contracts/TutorContracts";
import TutorDocuments from "../pages/tutors/profile/views/documents/TutorDocuments";
import TutorInfo from "../pages/tutors/profile/views/info/TutorInfo";
import TutorInvoices from "../pages/tutors/profile/views/invoices/TutorInvoices";
import TutorStats from "../pages/tutors/profile/views/stats/TutorStats";
import UsersWrapper from "../pages/users";
import UserCreate from "../pages/users/create/UserCreate";
import UserEdit from "../pages/users/edit/UserEdit";
import UserEditPermissions from "../pages/users/edit/UserEditPermissions";
import UsersListWrapper from "../pages/users/list/UsersListWrapper";
import UserChangelogsWrapper from "../pages/users/profile/views/activity-history/UserActivityHistoryWrapper";
import UserContractsWrapper from "../pages/users/profile/views/contracts/UserContractsWrapper";
import UserDocuments from "../pages/users/profile/views/documents/UserDocuments";
import UserInfo from "../pages/users/profile/views/info/UserInfo";
import UserPermissions from "../pages/users/profile/views/permissions/UserPermissions";
import UserRankings from "../pages/users/profile/views/rankings/UserRankings";
import UserScores from "../pages/users/profile/views/scores/UserScores";
import UserStats from "../pages/users/profile/views/stats/UserStats";
import { menuRoutes } from "./menu";
import CallsWrapper from "../pages/calls";
import CallClassificationsWrapper from "../pages/calls/call-classifications/CallClassificationsWrapper";
import CallsLanding from "../pages/calls/CallsLanding";
import CallResultClassificationsWrapper from "../pages/calls/classifications/CallResultClassificationsWrapper";
import CommunicationsWrapper from "../pages/calls/communications/CommunicationsWrapper";
import CommunicationDetailPage from "../pages/calls/communications/CommunicationDetailPage";
import FacilitatorAssignmentsWrapper from "../pages/calls/facilitator/FacilitatorAssignmentsWrapper";
import FacilitatorPendingExtrasWrapper from "../pages/calls/facilitator/FacilitatorPendingExtrasWrapper";
import FacilitatorScheduledCallsWrapper from "../pages/calls/facilitator/FacilitatorScheduledCallsWrapper";
import FacilitatorTotalCallsWrapper from "../pages/calls/facilitator/FacilitatorTotalCallsWrapper";
import PlatformAdvancesWrapper from "../pages/calls/platform-advances/PlatformAdvancesWrapper";
import CallListWrapper from "../pages/calls/list/CallListWrapper";
import CallInfo from "../pages/calls/profile/info/CallInfo";
import CallRecords from "../pages/calls/profile/records/CallRecords";
import ClientCallsListWrapper from "../pages/clients/profile/views/calls/ClientCallsListWrapper";
import UserCallsListWrapper from "../pages/users/profile/views/calls/UserCallsListWrapper";
import CommissionsSettingsPage from "../pages/settings/commissions/CommissionsSettingsPage";



const protectedRoutes = [
	/******************************************************
	 * Dashboard
	 ******************************************************/
	{
		path: menuRoutes.dashboard.path,
		element: <Dashboard />,
		access: {
			facilitatorAnyOf: ['facilitator', 'facilitator_manager'],
			anyOf: [
				{
					group: "dashboard",
					action: "get_dashboard_information"
				},
				{
					group: "dashboard",
					action: "show_complete_dashboard"
				}
			]
		},
	},

	/******************************************************
	 * Organisations
	 ******************************************************/
	{
		path: menuRoutes.organisations.path,
		element: <OrganisationWrapper />,
		sub: [
			{
				element: <OrganisationsListWrapper />,
				access: {
					group: "companies",
					action: "list_company",
				},
				index: true,
			},
			{
				element: <OrganisationCreate />,
				path: menuRoutes.organisations.create,
				access: {
					group: "companies",
					action: "create_company"
				}
			},
			{
				element: <OrganisationEdit />,
				path: ':id/edit',
				access: {
					group: "companies",
					action: "edit_company"
				}
			}
		],
	},

	/******************************************************
	 * Roles
	 ******************************************************/
	{
		path: menuRoutes.roles.path,
		element: <RolesWrapper />,
		sub: [
			{
				element: <RolesListWrapper />,
				access: {
					group: 'roles',
					action: 'list_roles'
				},
				index: true,
			},
			{
				element: <RoleCreate />,
				path: menuRoutes.roles.create,
				access: {
					group: 'roles',
					action: 'create_roles'
				}
			},
			{
				element: <RoleEdit />,
				path: menuRoutes.roles.edit,
				access: {
					group: 'roles',
					action: 'edit_roles'
				}
			},
		]
	},

	/******************************************************
	 * Users
	 ******************************************************/
	{
		path: menuRoutes.users.path,
		element: <UsersWrapper />,
		sub: [
			{
				element: <UsersListWrapper />,
				access: {
					group: 'user',
					action: 'list_user'
				},
				index: true,
			},
			{
				element: <UserInfo />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.info,
				access: {
					group: 'user',
					action: 'get_user'
				},
			},
			{
				element: <UserStats />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.stats,
				access: {
					group: 'user',
					action: 'user_profile_stats'
				},
			},
			{
				element: <UserScores />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.scores,
				access: {
					group: 'user',
					action: 'get_user'
				},
			},
			{
				element: <UserRankings />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.rankings,
				access: {
					group: 'user',
					action: 'show_user_rankings'
				},
			},
			{
				element: <UserDocuments />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.documents,
				access: {
					group: 'user',
					action: 'user_profile_documents'
				},
			},
			{
				element: <UserPermissions />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.permissions,
				access: {
					group: 'user',
					action: 'user_profile_permissions'
				},
			},
			{
				element: <UserContractsWrapper />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.contract_history,
				access: {
					group: 'user',
					action: 'user_profile_contract_history'
				},
			},
			{
				element: <UserChangelogsWrapper />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.activity,
				access: {
					group: 'user',
					action: 'user_profile_activity'
				},
			},
			{
				element: <UserCreate />,
				path: menuRoutes.users.create,
				access: {
					group: 'user',
					action: 'create_user'
				}
			},
			{
				element: <UserCallsListWrapper />,
				path: menuRoutes.users.profile.path + menuRoutes.users.profile.calls,
				access: {
					group: 'calls',
					action: 'admin_calls'
				}
			},
			{
				element: <UserEdit />,
				path: menuRoutes.users.edit,
				access: {
					group: 'user',
					action: 'edit_user'
				}
			},
			{
				element: <UserEditPermissions />,
				path: menuRoutes.users.edit_permissions,
				access: {
					group: 'user',
					action: 'edit_user'
				}
			},
		]
	},

	/******************************************************
	 * Tutors
	 ******************************************************/
	{
		path: menuRoutes.tutors.path,
		element: <TutorsWrapper />,
		sub: [
			{
				element: <TutorsListWrapper />,
				access: {
					group: 'tutors',
					action: 'list_tutors'
				},
				index: true,
			},
			{
				element: <TutorInfo />,
				path: menuRoutes.tutors.profile.path + menuRoutes.tutors.profile.info,
				access: {
					group: 'tutors',
					action: 'get_tutors'
				},
			},
			{
				element: <TutorStats />,
				path: menuRoutes.tutors.profile.path + menuRoutes.tutors.profile.stats,
				access: {
					group: 'tutors',
					action: 'tutors_stats'
				},
			},
			{
				element: <TutorDocuments />,
				path: menuRoutes.tutors.profile.path + menuRoutes.tutors.profile.documents,
				access: {
					group: 'tutors',
					action: 'tutors_documentation'
				},
			},
			{
				element: <TutorInvoices />,
				path: menuRoutes.tutors.profile.path + menuRoutes.tutors.profile.invoices,
				access: {
					group: 'tutors',
					action: 'tutors_invoices'
				},
			},
			{
				element: <TutorContracts />,
				path: menuRoutes.tutors.profile.path + menuRoutes.tutors.profile.contracts,
				access: {
					group: 'tutors',
					action: 'tutors_pending_contracts'
				},
			},
			{
				element: <TutorCreate />,
				path: menuRoutes.tutors.create,
				access: {
					group: 'tutors',
					action: 'create_tutors'
				}
			},
			{
				element: <TutorEdit />,
				path: menuRoutes.tutors.edit,
				access: {
					group: 'tutors',
					action: 'edit_tutors'
				}
			},
		]
	},

	/******************************************************
	 * Products
	 ******************************************************/
	{
		path: menuRoutes.products.path,
		element: <ProductsWrapper />,
		sub: [
			{
				element: <ProductsListWrapper excludeSubsidisedFromList />,
				access: {
					group: 'products',
					action: 'list_products'
				},
				index: true,
			},
			{
				element: (
					<ProductsListWrapper
						defaultToSubsidisedOnly
						hideProductTypeFilter
						title='Listado de acciones bonificadas'
					/>
				),
				path: 'acciones-bonificadas',
				access: {
					group: 'products',
					action: 'list_products'
				},
			},
			{
				element: <ProductCreate />,
				path: menuRoutes.products.create,
				access: {
					group: 'products',
					action: 'create_products'
				}
			},
			{
				element: <ProductEdit />,
				path: menuRoutes.products.edit,
				access: {
					group: 'products',
					action: 'edit_products'
				}
			},
			{
				element: <InspectorCredentialsListWrapper />,
				path: 'inspector-credentials',
				access: {
					group: 'inspector_credentials',
					action: 'list_inspector_credentials'
				}
			},
			{
				element: <InspectorCredentialsCreate />,
				path: 'inspector-credentials/create',
				access: {
					group: 'inspector_credentials',
					action: 'create_inspector_credentials'
				}
			},
			{
				element: <InspectorCredentialsEdit />,
				path: 'inspector-credentials/:id/edit',
				access: {
					group: 'inspector_credentials',
					action: 'edit_inspector_credentials'
				}
			}
		]
	},

	/******************************************************
	 * States
	 ******************************************************/
	{
		path: menuRoutes.states.path,
		element: <StatesWrapper />,
		sub: [
			{
				element: <StatesListWrapper />,
				access: {
					group: 'statuses',
					action: 'admin_statuses'
				},
				index: true,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract_product,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract_invoicing,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract_incidence,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract_blocked,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.contract_commission,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.expiration,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.expiration_management,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.invoice,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.incidence,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.renovation,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.order,
			},
			{
				element: <StatesListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.list.lead,
			},
			{
				element: <KoReasonsListWrapper />,
				path: menuRoutes.states.path + menuRoutes.states.koReasons,
				access: {
					group: 'statuses',
					action: 'admin_statuses'
				},
			},
			{
				element: <KoReasonCreate />,
				path: menuRoutes.states.path + menuRoutes.states.koReasons + '/create',
				access: {
					group: 'ko_reasons',
					action: 'create_ko_reasons'
				},
			},
			{
				element: <KoReasonEdit />,
				path: menuRoutes.states.path + menuRoutes.states.koReasons + '/:id/edit',
				access: {
					group: 'ko_reasons',
					action: 'edit_ko_reasons'
				},
			},
			{
				element: <StateCreate />,
				path: menuRoutes.states.create,
				access: {
					group: 'statuses',
					action: 'create_statuses'
				}
			},
			{
				element: <StateEdit />,
				path: menuRoutes.states.edit,
				access: {
					group: 'statuses',
					action: 'edit_statuses'
				}
			},
		]
	},

	/******************************************************
	 * Invoices
	 ******************************************************/
	{
		path: menuRoutes.invoices.path,
		element: <InvoicesWrapper />,
		sub: [
			{
				element: <InvoicesListWrapper />,
				access: {
					group: 'invoices',
					action: 'list_invoices'
				},
				index: true,
			},
		{
			element: <NonStandardInvoiceCreate />,
			path: menuRoutes.invoices.nonStandard,
			access: {
				group: 'invoices',
				action: 'create_invoices'
			}
		},
		{
			element: <InvoiceEdit />,
			path: menuRoutes.invoices.edit,
			access: {
				group: 'invoices',
				action: 'edit_invoices'
			}
		},
			{
				element: <InvoiceInfo />,
				path: menuRoutes.invoices.profile.path + menuRoutes.invoices.profile.info,
				access: {
					group: 'invoices',
					action: 'get_invoices'
				},
			},
			{
				element: <InvoiceActivityHistoryWrapper />,
				path: menuRoutes.invoices.profile.path + menuRoutes.invoices.profile.activityHistory,
				access: {
					group: 'invoices',
					action: 'invoice_changes_log',
				},
			},
			{
				element: <InvoiceExpirations />,
				path: menuRoutes.invoices.profile.path + menuRoutes.invoices.profile.expirations,
				access: {
					group: 'expirations',
					action: 'admin_expirations',
				},
			},
		]
	},

	/******************************************************
	 * Corporations
	 ******************************************************/
	{
		path: menuRoutes.corporations.path,
		element: <CorporationsWrapper />,
		sub: [
			{
				element: <CorporationsListWrapper />,
				access: {
					group: 'corporation',
					action: 'list_corporation'
				},
				index: true,
			},
			{
				element: <CorporationDetailPage />,
				path: menuRoutes.corporations.detail,
				access: {
					group: 'corporation',
					action: 'edit_corporation'
				}
			},
		]
	},

	/******************************************************
	 * Networks
	 ******************************************************/
	{
		path: menuRoutes.networks.path,
		element: <NetworksWrapper />,
		sub: [
			{
				element: <NetworksListWrapper />,
				access: {
					group: 'commercial_network',
					action: 'list_commercial_network'
				},
				index: true,
			},
			{
				element: <NetworkDetailPage />,
				path: menuRoutes.networks.detail,
				access: {
					group: 'commercial_network',
					action: 'edit_commercial_network'
				},
			},
			{
				element: <NetworkSettlementsListWrapper />,
				path: menuRoutes.networks.settlements.slice(1),
				access: {
					group: 'commercial_network',
					action: 'list_commercial_network'
				},
			},
			{
				element: <NetworkSettlementContractsListWrapper />,
				path: menuRoutes.networks.settlementDetail.slice(1),
				access: {
					group: 'commercial_network',
					action: 'list_commercial_network'
				},
			},
		]
	},

	/******************************************************
	 * Departments
	 * ****************************************************/
	{
		path: menuRoutes.departments.path,
		element: <DepartmentsWrapper />,
		sub: [
			{
				element: <DepartmentsListWrapper />,
				access: {
					group: 'departments',
					action: 'list_departments'
				},
				index: true,
			},
			{
				element: <DepartmentDetailPage />,
				path: menuRoutes.departments.detail,
				access: {
					group: 'departments',
					action: 'edit_departments'
				},
			},
		]
	},

	/******************************************************
	 * Clients
	 ******************************************************/
	{
		path: menuRoutes.clients.path,
		element: <ClientsWrapper />,
		access: {
			group: 'clients',
			action: 'admin_clients'
		},
		sub: [
			{
				element: <ClientsListWrapper />,
				access: {
					group: 'clients',
					action: 'list_clients'
				},
				index: true,
			},
			{
				element: <ClientInfo />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.info,
				access: {
					group: 'clients',
					action: 'get_clients'
				},
			},
			{
				element: <ClientStudents />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.students,
				access: {
					group: 'clients',
					action: 'get_clients_students'
				},
			},
			{
				element: <ClientContractsWrapper />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.contracts,
				access: {
					group: 'clients',
					action: 'get_clients_contracts'
				},
			},
			{
				element: <ClientConsultancy />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.consultancy,
				access: {
					group: 'clients',
					action: 'get_clients_consultancy'
				},
			},
			{
				element: <ClientInvoicesWrapper />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.invoices,
				access: {
					group: 'clients',
					action: 'get_clients_invoicing'
				},
			},
			{
				element: <ClientCallsListWrapper />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.calls,
				access: {
					group: 'clients',
					action: 'get_clients_calls'
				},
			},
			{
				element: <ClientComments />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.comments,
				access: {
					group: 'clients',
					action: 'get_clients_comments'
				},
			},
			{
				element: <ClientCreditHistory />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.creditHistory,
				access: {
					group: 'clients',
					action: 'get_clients_credit_history'
				},
			},
			{
				element: <ClientActivityHistoryWrapper />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.activityHistory,
				access: {
					group: 'clients',
					action: 'get_clients_activity_history'
				},
			},

			{
				element: <ClientCommercialNetworks />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.commercialNetworks,
				access: {
					group: 'clients',
					action: 'manage_clients_commercial_networks'
				},
			},
			{
				element: <ClientCreate />,
				path: menuRoutes.clients.create,
				access: {
					group: 'clients',
					action: 'create_clients'
				}
			},
			{
				element: <ClientEdit />,
				path: menuRoutes.clients.edit,
				access: {
					group: 'clients',
					action: 'edit_clients'
				}
			},
		]
	},

	/******************************************************
	 * Students
	 ******************************************************/
	{
		path: menuRoutes.students.path,
		element: <StudentsWrapper />,
		sub: [
			{
				element: <StudentsListWrapper />,
				access: {
					group: 'students',
					action: 'list_students'
				},
				index: true,
			},
			{
				element: <StudentInfo />,
				path: menuRoutes.students.profile.path + menuRoutes.students.profile.info,
				access: {
					group: 'students',
					action: 'get_students'
				},
			},
			{
				element: <StudentActivityHistoryWrapper />,
				path: menuRoutes.students.profile.path + menuRoutes.students.profile.activityHistory,
				access: {
					group: 'students',
					action: 'student_changes_log'
				},
			},
			{
				element: <StudentCreate />,
				path: menuRoutes.students.create,
				access: {
					group: 'students',
					action: 'create_students'
				}
			},
			{
				element: <StudentEdit />,
				path: menuRoutes.students.edit,
				access: {
					group: 'students',
					action: 'edit_students'
				}
			}
		]
	},

	/******************************************************
	 * Consultancies
	 ******************************************************/
	{
		path: menuRoutes.consultancies.path,
		element: <ConsultanciesWrapper />,
		sub: [
			{
				element: <ConsultanciesListWrapper />,
				access: {
					group: 'consultancies',
					action: 'list_consultancies'
				},
				index: true,
			},
			{
				element: <CreateConsultancy />,
				path: menuRoutes.consultancies.create,
				access: {
					group: 'consultancies',
					action: 'create_consultancies'
				}
			},
			{
				element: <EditConsultancy />,
				path: menuRoutes.consultancies.edit,
				access: {
					group: 'consultancies',
					action: 'edit_consultancies'
				}
			}
		]
	},

	/******************************************************
	 * General configuration
	 ******************************************************/
	{
		path: '',
		element: <GeneralConfigurationWrapper />,
		sub: [
			{
				element: <ConfigListWrapper />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.educationalLevels,
			},
			{
				element: <ConfigListWrapper />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.professionalCategories,
			},
			{
				element: <ConfigListWrapper />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.quotationGroups,
			},
			{
				element: <ConfigListWrapper />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.campaigns,
			},
			{
				element: <TrainingActionGroupsSettingsPage />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingActionGroups,
				access: {
					group: 'products',
					action: 'admin_products'
				},
			},
			{
				element: <ProfessionalAreasSettingsPage />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.professionalAreas,
				access: {
					group: 'products',
					action: 'admin_products'
				},
			},
			{
				element: <TrainingModalitiesSettingsPage />,
				path: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingModalities,
				access: {
					group: 'products',
					action: 'admin_products'
				},
			},
		]
	},

	/******************************************************
	 * Contracts
	 ******************************************************/
	{
		path: menuRoutes.contracts.path,
		element: <ContractsLayoutWrapper />,
		sub: [
			{
				element: <ContractsListWrapper />,
				path: menuRoutes.contracts.path,
				access: {
					group: 'contracts',
					action: 'list_contracts'
				},
				index: true,
			},
			{
				element: <ContractCreate />,
				path: menuRoutes.contracts.create,

			},
			{
				element: <ContractEdit />,
				path: menuRoutes.contracts.edit,
				access: {
					group: 'contracts',
					action: 'edit_contracts'
				}
			},
			{
				element: <ContractInfo />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.info,
				access: {
					group: 'contracts',
					action: 'get_contracts'
				},
			},
			{
				element: <ContractInvoicing />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.invoicing,
				access: {
					group: 'invoices',
					action: 'list_invoices'
				},
			},
			{
				element: <ContractCalls />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.calls,
				access: {
					group: 'contracts',
					action: 'get_contracts'
				},
			},
			{
				element: <ContractDocuments />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.documents,
				access: {
					group: 'contracts',
					action: 'get_contracts'
				},
			},
			{
				element: <ContractIncidenceWrapper />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.incidences,
				access: {
					group: 'contracts',
					action: 'list_contract_incidences'
				},
			},
			{
				element: <ContractStatesHistoryWrapper />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.statesHistory,
				access: {
					group: 'contracts',
					action: 'show_contract_status_history'
				},
			},
			{
				element: <ContractChangelogsWrapper />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.changelogs,
				access: {
					group: 'contracts',
					action: 'contract_changes_log'
				},
			},
			{
				element: <ContractComments />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.comments,
				access: {
					group: 'contracts',
					action: 'get_contract_comments'
				},
			},
			{
				element: <ContractFacilitatorTracking />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.tracking,
				access: {
					group: 'contracts',
					action: 'show_contract_tracking'
				},
			},
			{
				element: <ContractFacilitatorExtras />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.extras,
				access: {
					group: 'contracts',
					action: 'show_contract_extras'
				},
			},
			{
				element: <ContractScoresHistory />,
				path: menuRoutes.contracts.profile.path + menuRoutes.contracts.profile.scoresHistory,
			},
		]
	},

	/******************************************************
	 * Rankings
	 ******************************************************/
	{
		path: menuRoutes.userRankings.path,
		element: <RankingsIndexWrapper />,
		sub: [
			{
				element: <UsersRankingsListWrapper />,
				path: menuRoutes.userRankings.path,
				access: {
					group: 'rankings',
					action: 'list_rankings'
				},
				index: true,
			},
			{
				element: <RankingInfo />,
				path: menuRoutes.userRankings.path + menuRoutes.userRankings.profile,
				access: {
					group: 'rankings',
					action: 'list_rankings'
				},
			},
		]
	},

	/******************************************************
	 * All Rankings Management
	 ******************************************************/
	{
		path: menuRoutes.rankings.path,
		element: <RankingsIndexWrapper />,
		sub: [
			{
				element: <RankingsPage />,
				path: menuRoutes.rankings.path,
				access: {
					group: 'rankings',
					action: 'list_rankings'
				},
				index: true,
			},
			{
				element: <RankingInfo />,
				path: menuRoutes.rankings.path + '/:id/info',
				access: {
					group: 'rankings',
					action: 'list_rankings'
				},
			},
		]
	},

	/******************************************************
	 * Settings
	 ******************************************************/
	{
		path: menuRoutes.settings.path,
		element: <SettingsWrapper />,
		sub: [
			{
				element: <GeneralsSettingsPage />,
				path: menuRoutes.settings.path,
			},
			{
				element: <OrdersSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.orders,
			},
			{
				element: <ContractsSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.contracts,
				// access: {
				//     group: 'settings',
				//     action: 'admin_settings_contracts'
				// },
			},
			{
				element: <TutorSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.tutors,
				// access: {
				//     group: 'settings',
				//     action: 'admin_settings_tutors'

			},
			{
				element: <HolidaysSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.holidays,
				// access: {
				//     group: 'settings',
				//     action: 'admin_settings_holidays'
				// },
			},
			{
				element: <TemplatesSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.templates,
				access: {
					group: 'user',
					action: 'manage_company_email_templates'
				},
			},
			{
				element: <EventsSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.events,
				access: {
					group: 'events',
					action: 'list_events'
				},
			},
			{
				element: <RankingsSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.rankings,
				access: {
					group: 'rankings',
					action: 'list_rankings'
				},
			},
			{
				element: <DocumentTypesSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.document_types,
				access: {
					group: 'document_type',
					action: 'list_document_type'
				},
			},
			{
				element: <ProductTypesSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.product_types,
				access: {
					group: 'product_types',
					action: 'list_product_types'
				},
			},
			{
				element: <FundaeGroupingsSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.fundae_groupings,
				access: {
					group: 'contracts',
					action: 'admin_contracts'
				},
			},
			{
				element: <CommissionsSettingsPage />,
				path: menuRoutes.settings.path + menuRoutes.settings.commissions,
				access: {
					group: 'user',
					action: 'show_user_commissions'
				},
			}
		]
	},

	/******************************************************
	 * Incidences
	 ******************************************************/
	{
		path: menuRoutes.incidences.path,
		element: <IncidencesWrapper />,
		sub: [
			{
				element: <IncidencesListWrapper />,
				access: {
					group: 'incidences',
					action: 'list_incidences'
				},
				index: true,
			},
			{
				element: <TutorIncidencesListWrapper />,
				path: menuRoutes.incidences.path + menuRoutes.incidences.tutor,
				access: {
					anyOf: [
						{
							group: 'incidences',
							action: 'show_user_tutor_incidences'
						},
						{
							group: 'incidences',
							action: 'show_all_tutor_incidences'
						}
					]
				},
			},
			{
				element: <ContractsListWrapper mode='blocked' />,
				path: menuRoutes.incidences.path + menuRoutes.incidences.blockedContracts,
				access: {
					group: 'contracts',
					action: 'list_contracts'
				},
			},
			{
				element: <IncidenceCreate />,
				path: menuRoutes.incidences.path + menuRoutes.incidences.create,
				access: {
					group: 'incidences',
					action: 'create_incidences'
				}
			},
			{
				element: <IncidenceEdit />,
				path: menuRoutes.incidences.path + menuRoutes.incidences.edit,
				access: {
					group: 'incidences',
					action: 'edit_incidences'
				}
			},
			{
				element: <IncidenceInfo />,
				path: menuRoutes.incidences.profile.path + menuRoutes.incidences.profile.info,
				access: {
					group: 'incidences',
					action: 'get_incidences'
				},
			},
			{
				element: <IncidenceDocuments />,
				path: menuRoutes.incidences.profile.path + menuRoutes.incidences.profile.documents,
				access: {
					group: 'incidences',
					action: 'admin_incidence_documents'
				},
			},
			{
				element: <IncidenceComments />,
				path: menuRoutes.incidences.profile.path + menuRoutes.incidences.profile.comments,
				access: {
					group: 'incidences',
					action: 'admin_incidence_comments'
				},
			}
		]
	},

	/******************************************************
	 * Incidences Types
	 ******************************************************/
	{
		path: menuRoutes.incidenceTypes.path,
		element: <IncidenceTypesWrapper />,
		sub: [
			{
				element: <IncidenceTypesListWrapper />,
				access: {
					group: 'incidence_types',
					action: 'list_incidence_types'
				},
				index: true,
			},
			{
				element: <IncidenceTypeCreate />,
				path: menuRoutes.incidenceTypes.create,
				access: {
					group: 'incidence_types',
					action: 'create_incidence_types'
				}
			},
			{
				element: <IncidenceTypeEdit />,
				path: menuRoutes.incidenceTypes.edit,
				access: {
					group: 'incidence_types',
					action: 'edit_incidence_types'
				}
			}
		]
	},

	/******************************************************
	 * Orders
	 ******************************************************/
	{
		path: menuRoutes.orders.path,
		element: <OrderWrapper />,
		sub: [
			{
				element: <OrdersListWrapper />,
				access: {
					group: 'orders',
					action: 'list_orders'
				},
				sub: [
					{
						element: <OrdersList />,
						path: menuRoutes.orders.path + menuRoutes.orders.list,
					},
					{
						element: <OrdersCalendarPage />,
						path: menuRoutes.orders.path + menuRoutes.orders.calendar,
					},
				]
			},
			{
				element: <OrderCreate />,
				path: menuRoutes.orders.path + menuRoutes.orders.create,
				access: {
					group: 'orders',
					action: 'create_orders'
				}
			},
			{
				element: <OrderEdit />,
				path: menuRoutes.orders.path + menuRoutes.orders.edit,
				access: {
					group: 'orders',
					action: 'edit_orders'
				}
			},
			{
				element: <OrderProfileWrapper />,
				access: {
					group: 'orders',
					action: 'get_orders'
				},
				sub: [
					{
						element: <OrderInfo />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.info,
						access: {
							group: 'orders',
							action: 'get_orders'
						},
					},
					{
						element: <OrderStats />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.stats,
						access: {
							group: 'orders',
							action: 'orders_stats'
						},
					},
					{
						element: <OrderContracts />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.contracts,
						access: {
							group: 'orders',
							action: 'orders_contracts'
						},
					},
					{
						element: <OrderCampaigns />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.campaigns,
						access: {
							group: 'order_campaigns',
							action: 'get_order_campaigns'
						},
					},
					{
						element: <OrderGroupCodes />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.groupCodes,
						access: {
							group: 'group_codes',
							action: 'list_group_codes'
						},
					},
					{
						element: <ContractAssignment />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.assignments,
						access: {
							group: 'orders',
							action: 'assign_order_contracts_tutor'
						},
					},
					{
						element: <ContractExports />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.exports,
						access: {
							group: 'orders',
							action: 'export_order_contracts'
						},
					},
					{
						element: <OrderXmlHistory />,
						path: menuRoutes.orders.profile.path + menuRoutes.orders.profile.xmlHistory,
						access: {
							group: 'orders',
							action: 'export_order_contracts'
						},
					},
				]
			},
		]
	},

	/******************************************************
	 * Order Types
	 ******************************************************/
	{
		path: menuRoutes.orderTypes.path,
		element: <OrderTypesWrapper />,
		sub: [
			{
				element: <OrderTypesListWrapper />,
				access: {
					group: 'order_types',
					action: 'list_order_types'
				},
				index: true,
			},
			{
				element: <OrderTypeCreate />,
				path: menuRoutes.orderTypes.create,
				access: {
					group: 'order_types',
					action: 'create_order_types'
				}
			},
			{
				element: <OrderTypeEdit />,
				path: menuRoutes.orderTypes.edit,
				access: {
					group: 'order_types',
					action: 'edit_order_types'
				}
			}
		]
	},

	/******************************************************
	 * Expirations
	 ******************************************************/
	{
		path: "/expirations",
		element: <ExpirationWrapper />,
		sub: [
			{
				element: <ExpirationListWrapper />,
				index: true,
			},
			{
				path: 'create',
				element: <ExpirationCreate />,
			},
			{
				path: ':id/edit',
				element: <ExpirationEdit />,
			},
			{
				path: ':id/view',
				element: <ViewExpiration />,
			},
		]
	},

	/******************************************************
	 * Leads
	 ******************************************************/
	{
		path: menuRoutes.leads.path,
		element: <LeadsWrapper />,
		sub: [
			{
				element: <LeadListWrapper />,
				access: {
					group: 'leads',
					action: 'admin_leads'
				},
				index: true,
			},
			{
				element: <LeadEdit />,
				path: menuRoutes.leads.edit,
				access: {
					group: 'leads',
					action: 'edit_leads'
				}
			},
			{
				element: <LeadInfo />,
				path: menuRoutes.leads.profile.path + menuRoutes.leads.profile.info,
				access: {
					group: 'leads',
					action: 'get_leads'
				},
			},
			{
				element: <LeadStatusHistory />,
				path: menuRoutes.leads.profile.path + menuRoutes.leads.profile.statusHistory,
				access: {
					group: 'leads',
					action: 'get_leads'
				},
			},
			{
				element: <LeadComments />,
				path: menuRoutes.leads.profile.path + menuRoutes.leads.profile.comments,
				access: {
					group: 'leads',
					action: 'get_leads'
				},
			},
		]
	},

    /******************************************************
     * Calls
     ******************************************************/
    {
        path: menuRoutes.calls.path,
        element: <CallsWrapper />,
        sub: [
            {
                element: <CallsLanding />,
                index: true,
            },
            {
                element: <CallListWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.list,
                access: {
                    group: 'calls',
                    action: 'list_calls'
                },
            },
            {
                element: <FacilitatorTotalCallsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.total,
                access: {
                    group: 'calls',
                    action: 'list_calls'
                },
            },
            {
                element: <CallResultClassificationsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.classifications,
                access: {
                    group: 'call_result_classifications',
                    action: 'list_call_result_classifications'
                },
            },
            {
                element: <CallClassificationsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.callClassifications,
                access: {
                    group: 'call_classifications',
                    action: 'list_call_classifications'
                },
            },
            {
                element: <CommunicationsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.communications,
                access: {
                    group: 'communications',
                    action: 'list_communications'
                },
            },
            {
                element: <CommunicationDetailPage />,
                path: menuRoutes.calls.path + menuRoutes.calls.communicationDetail,
                access: {
                    group: 'communications',
                    action: 'list_communications'
                },
            },
            {
                element: <FacilitatorAssignmentsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.assignments,
                access: {
                    group: 'user',
                    action: 'show_all_system_facilitators'
                },
            },
            {
                element: <FacilitatorPendingExtrasWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.pendingExtras,
                access: {
                    group: 'contracts',
                    action: 'show_all_pending_contract_extras'
                },
            },
            {
                element: <FacilitatorScheduledCallsWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.scheduled,
                access: {
                    group: 'contracts',
                    action: 'show_contract_tracking'
                },
            },
            {
                element: <PlatformAdvancesWrapper />,
                path: menuRoutes.calls.path + menuRoutes.calls.platformAdvances,
                access: {
                    group: 'platform_advances',
                    action: 'list_platform_advances'
                },
            },
			{
				element: <CallInfo />,
				path: menuRoutes.calls.profile.path + menuRoutes.calls.profile.info,
				access: {
					group: 'calls',
					action: 'admin_calls'
				},
			},
			{
				element: <CallRecords />,
				path: menuRoutes.calls.profile.path + menuRoutes.calls.profile.records,
				access: {
					group: 'calls',
					action: 'admin_calls'
				},
			},
            // {
            //     element: <CallEdit />,
            //     path: menuRoutes.leads.edit,
            //     access: {
            //         group: 'leads',
            //         action: 'edit_leads'
            //     }
            // },
        ]
    },

	/******************************************************
	 * Remittances
	 * ******************************************************/
	{
		path: menuRoutes.remittances.path,
		element: <RemittancesWrapper />,
		sub: [
			{
				element: <RemittancesListWrapper />,
				index: true,
			},
		]
	},

	/******************************************************
	 * Tutors admin panel
	 ******************************************************/
	{
		path: '',
		element: <TutorsLayoutWrapper />,
		sub: [
			{
				element: <MyTutorials />,
				path: menuRoutes.tutor_panel.tutorials,
			},
			{
				element: <ListMyInvoicesWrapper />,
				path: menuRoutes.tutor_panel.invoices,
			},
			{
				element: <MyCalendar />,
				path: menuRoutes.tutor_panel.calendar,
			},
			{
				element: <ListMyDocumentsWrapper />,
				path: menuRoutes.tutor_panel.documents,
			},
			{
				element: <TutorProfile />,
				path: menuRoutes.tutor_panel.profile,
				index: true,
			},
		]
	},
];

const contents = [...protectedRoutes];
export default contents;
